/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateMeRequestDto
 */
export interface UpdateMeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateMeRequestDto
     */
    language?: UpdateMeRequestDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeRequestDto
     */
    currentPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeRequestDto
     */
    newPassword?: string;
}


/**
 * @export
 */
export const UpdateMeRequestDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type UpdateMeRequestDtoLanguageEnum = typeof UpdateMeRequestDtoLanguageEnum[keyof typeof UpdateMeRequestDtoLanguageEnum];


/**
 * Check if a given object implements the UpdateMeRequestDto interface.
 */
export function instanceOfUpdateMeRequestDto(value: object): value is UpdateMeRequestDto {
    return true;
}

export function UpdateMeRequestDtoFromJSON(json: any): UpdateMeRequestDto {
    return UpdateMeRequestDtoFromJSONTyped(json, false);
}

export function UpdateMeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateMeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : json['language'],
        'name': json['name'] == null ? undefined : json['name'],
        'currentPassword': json['currentPassword'] == null ? undefined : json['currentPassword'],
        'newPassword': json['newPassword'] == null ? undefined : json['newPassword'],
    };
}

export function UpdateMeRequestDtoToJSON(json: any): UpdateMeRequestDto {
    return UpdateMeRequestDtoToJSONTyped(json, false);
}

export function UpdateMeRequestDtoToJSONTyped(value?: UpdateMeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'language': value['language'],
        'name': value['name'],
        'currentPassword': value['currentPassword'],
        'newPassword': value['newPassword'],
    };
}

